import { z } from 'zod';
// =========================================================
// Schemas Zod para GET /api/importaciones?limite=N&offset=N.
// Historial paginado de ingestas de CSV.
// =========================================================
export const LIMITE_MAXIMO = 50;
export const LIMITE_DEFAULT = 10;
export const HistorialImportacionesRequestSchema = z.object({
    limite: z.coerce.number().int().positive().max(LIMITE_MAXIMO).default(LIMITE_DEFAULT),
    offset: z.coerce.number().int().nonnegative().default(0),
});
export const EstadoImportacionSchema = z.enum(['ok', 'parcial', 'duplicado_archivo', 'procesando']);
/**
 * Fila resumida del historial. NO trae el JSON de errores ni el contenido del
 * archivo — esos detalles vendrían de un endpoint de detalle a futuro.
 */
export const ImportacionResumenSchema = z.object({
    id: z.number().int().positive(),
    archivo_nombre: z.string(),
    estado: EstadoImportacionSchema,
    filas_totales: z.number().int().nonnegative(),
    batches_nuevos: z.number().int().nonnegative(),
    batches_duplicados: z.number().int().nonnegative(),
    batches_con_error: z.number().int().nonnegative(),
    /** Email del usuario que ejecutó la ingesta. Puede venir null en filas legacy. */
    usuario_email: z.string().nullable(),
    /** ISO UTC. */
    fecha_archivo: z.string(),
    /** Hash SHA-256 del archivo (hex, 64 chars). Útil para identificar duplicados. */
    archivo_hash: z.string().length(64),
});
export const HistorialImportacionesResponseSchema = z.object({
    items: z.array(ImportacionResumenSchema),
    total: z.number().int().nonnegative(),
});
//# sourceMappingURL=importaciones.js.map